import * as XLSX from "xlsx";
import { isValidNewsletterEmail } from "./parseNewsletterCsv";

const EXCEL_EXTENSIONS = [".xlsx", ".xls"];

const isExcelFile = (fileName) => {
  const lower = String(fileName || "").toLowerCase();
  return EXCEL_EXTENSIONS.some((ext) => lower.endsWith(ext));
};

export const spreadsheetRowsToListText = (rows) => {
  const lines = (Array.isArray(rows) ? rows : [])
    .map((row) => {
      if (Array.isArray(row)) {
        return String(row[0] ?? "").trim();
      }
      if (row && typeof row === "object") {
        const firstKey = Object.keys(row)[0];
        return firstKey ? String(row[firstKey] ?? "").trim() : "";
      }
      return String(row ?? "").trim();
    })
    .filter(Boolean);

  if (!lines.length) {
    return "";
  }

  const firstCandidate = lines[0].split(/[,;\t]/)[0].trim().replace(/^["']|["']$/g, "");
  const looksLikeHeader =
    !isValidNewsletterEmail(firstCandidate) && /email|e-mail|mail|indirizzo/i.test(lines[0]);

  return (looksLikeHeader ? lines.slice(1) : lines).join("\n");
};

export async function readNewsletterListFile(file) {
  if (!file) {
    return "";
  }

  if (isExcelFile(file.name)) {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: "array" });
    const sheetName = workbook.SheetNames?.[0];
    if (!sheetName) {
      return "";
    }
    const rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, defval: "" });
    return spreadsheetRowsToListText(rows);
  }

  return file.text();
}
